import { ReactElement, useCallback, useState } from 'react';
import styles from '@/styles/pages/home/join-us.module.less';
import Image from '@/components/LocalImage';
const JoinUs = (): ReactElement => {
    const __joinIcons = [
        {
            id: 0,
            name: 'feiji',
            url: 'mailto:admin@aicadegalaxy.com',
        },
        {
            id: 1,
            name: 'f',
        },
        {
            id: 2,
            name: 'tuite',
            url: 'https://twitter.com/AicadeGalaxy',
        },
        {
            id: 3,
            name: 'xiangji',
        },
    ];
    const hander = useCallback((item: any) => {
        if (item.url) {
            const w = window.open('about:blank');
            if (w) {
                w.location.href = item.url;
            }
        }
    }, []);
    const iconItems = __joinIcons.map((item) => <Image onClick={() => hander(item)} key={item.id} dir="/images/home" name={item.name} width="15" height="15" type="svg"></Image>);
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div className={styles['join']}>
            {isVisible && (
                <div style={{ display: isVisible ? '' : 'none' }} className={styles['join-us']}>
                    <div style={{ display: 'flex' }}>
                        <div className={styles['icon-style']}>{iconItems}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default JoinUs;
